var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("chart-card", [
                _c("div", { attrs: { slot: "card-head" }, slot: "card-head" }, [
                  _c("div", { staticClass: "flex justify-between" }, [
                    _c("div", [_vm._v("销售总额")]),
                    _c(
                      "div",
                      [
                        _c(
                          "el-tooltip",
                          { attrs: { content: "指标说明", placement: "top" } },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-warning-outline cursor-pointer",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { attrs: { slot: "card-content" }, slot: "card-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "text-3xl" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": _vm.info.cellNum.num,
                            duration: _vm.info.cellNum.duration,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "chart-container" }, [
                      _c("span", [_vm._v("周同比")]),
                      _c("span", { staticClass: "pl-2 pr-1" }, [_vm._v("12%")]),
                      _c("span", {
                        staticClass: "el-icon-caret-top text-red-400",
                      }),
                      _c("span", { staticClass: "pl-3" }, [_vm._v("日同比")]),
                      _c("span", { staticClass: "pl-2 pr-1" }, [_vm._v("11%")]),
                      _c("span", {
                        staticClass: "el-icon-caret-bottom text-green-400",
                      }),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { attrs: { slot: "card-footer" }, slot: "card-footer" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pt-3 border-t border-solid border-gray-300",
                      },
                      [_c("span", [_vm._v("日均销售额￥ 234.56")])]
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("chart-card", [
                _c("div", { attrs: { slot: "card-head" }, slot: "card-head" }, [
                  _c("div", { staticClass: "flex justify-between" }, [
                    _c("div", [_vm._v("访问量")]),
                    _c(
                      "div",
                      [
                        _c(
                          "el-tooltip",
                          { attrs: { content: "指标说明", placement: "top" } },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-warning-outline cursor-pointer",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { attrs: { slot: "card-content" }, slot: "card-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "text-3xl" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": _vm.info.visitNum.num,
                            duration: _vm.info.visitNum.duration,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("ve-line", {
                      attrs: {
                        height: "60px",
                        tooltip: _vm.options.visit.tooltip,
                        grid: _vm.options.visit.grid,
                        xAxis: _vm.options.visit.xAxis,
                        yAxis: _vm.options.visit.yAxis,
                        series: _vm.options.visit.series,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { attrs: { slot: "card-footer" }, slot: "card-footer" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pt-3 border-t border-solid border-gray-300",
                      },
                      [_c("span", [_vm._v("日访问量 1,234")])]
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("chart-card", [
                _c("div", { attrs: { slot: "card-head" }, slot: "card-head" }, [
                  _c("div", { staticClass: "flex justify-between" }, [
                    _c("div", [_vm._v("支付笔数")]),
                    _c(
                      "div",
                      [
                        _c(
                          "el-tooltip",
                          { attrs: { content: "指标说明", placement: "top" } },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-warning-outline cursor-pointer",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { attrs: { slot: "card-content" }, slot: "card-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "text-3xl" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": _vm.info.payCount.num,
                            duration: _vm.info.payCount.duration,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("ve-histogram", {
                      attrs: {
                        height: "60px",
                        tooltip: _vm.options.payNum.tooltip,
                        grid: _vm.options.payNum.grid,
                        xAxis: _vm.options.payNum.xAxis,
                        yAxis: _vm.options.payNum.yAxis,
                        series: _vm.options.payNum.series,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { attrs: { slot: "card-footer" }, slot: "card-footer" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pt-3 border-t border-solid border-gray-300",
                      },
                      [_c("span", [_vm._v("转化率 60%")])]
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("chart-card", [
                _c("div", { attrs: { slot: "card-head" }, slot: "card-head" }, [
                  _c("div", { staticClass: "flex justify-between" }, [
                    _c("div", [_vm._v("运营活动效果")]),
                    _c(
                      "div",
                      [
                        _c(
                          "el-tooltip",
                          { attrs: { content: "指标说明", placement: "top" } },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-warning-outline cursor-pointer",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { attrs: { slot: "card-content" }, slot: "card-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "text-3xl" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": _vm.info.operateEffect.num,
                            duration: _vm.info.operateEffect.duration,
                          },
                        }),
                        _c("span", [_vm._v("%")]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "progress-container" },
                      [
                        _c("el-progress", {
                          attrs: {
                            "show-text": false,
                            "stroke-width": 26,
                            percentage: 78,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  { attrs: { slot: "card-footer" }, slot: "card-footer" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pt-3 border-t border-solid border-gray-300",
                      },
                      [
                        _c("span", [_vm._v("周同比")]),
                        _c("span", { staticClass: "pl-2 pr-1" }, [
                          _vm._v("12%"),
                        ]),
                        _c("span", {
                          staticClass: "el-icon-caret-top text-green-400",
                        }),
                        _c("span", { staticClass: "pl-3" }, [_vm._v("日同比")]),
                        _c("span", { staticClass: "pl-2 pr-1" }, [
                          _vm._v("80%"),
                        ]),
                        _c("span", {
                          staticClass: "el-icon-caret-bottom text-red-400",
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }